import { render, staticRenderFns } from "./ContractResale.vue?vue&type=template&id=b652dad0&"
import script from "./ContractResale.vue?vue&type=script&lang=js&"
export * from "./ContractResale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports